
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_ftugk_17",
  "arrow": "awsui_arrow_18eso_ftugk_17",
  "in-filtering-token-root": "awsui_in-filtering-token-root_18eso_ftugk_77",
  "in-filtering-token-nested": "awsui_in-filtering-token-nested_18eso_ftugk_77",
  "has-caret": "awsui_has-caret_18eso_ftugk_113",
  "placeholder": "awsui_placeholder_18eso_ftugk_116",
  "pressed": "awsui_pressed_18eso_ftugk_132",
  "disabled": "awsui_disabled_18eso_ftugk_138",
  "in-filtering-token": "awsui_in-filtering-token_18eso_ftugk_77",
  "readonly": "awsui_readonly_18eso_ftugk_159",
  "compact": "awsui_compact_18eso_ftugk_171",
  "grouped-with-error": "awsui_grouped-with-error_18eso_ftugk_171",
  "grouped-with-warning": "awsui_grouped-with-warning_18eso_ftugk_171",
  "invalid": "awsui_invalid_18eso_ftugk_180",
  "warning": "awsui_warning_18eso_ftugk_189",
  "custom-option": "awsui_custom-option_18eso_ftugk_204",
  "inline-tokens": "awsui_inline-tokens_18eso_ftugk_209",
  "grouped": "awsui_grouped_18eso_ftugk_171",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_18eso_ftugk_258",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_18eso_ftugk_262",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_18eso_ftugk_268",
  "grouped-vertical-first": "awsui_grouped-vertical-first_18eso_ftugk_272",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_18eso_ftugk_276",
  "grouped-vertical-last": "awsui_grouped-vertical-last_18eso_ftugk_282",
  "grouped-with-action": "awsui_grouped-with-action_18eso_ftugk_286",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_18eso_ftugk_318",
  "grouped-vertical-only": "awsui_grouped-vertical-only_18eso_ftugk_318",
  "grouped-vertical": "awsui_grouped-vertical_18eso_ftugk_272",
  "grouped-horizontal": "awsui_grouped-horizontal_18eso_ftugk_258"
};
  